import * as rewardService from "../../services/rewards-admin"
import REWARD from "../constants"

const setRewardValue = (reward, key, value) => (dispatch) => {
  return dispatch({
    type: REWARD.SET_VALUE,
    reward,
    key,
    value
  })
}

export const setReward = (reward) => {
  return {
    type: REWARD.SET_OBJECT,
    reward
  }
}

export const setReferenceData = (referenceData) => {
  return {
    type: REWARD.SET_REFERENCE_DATA,
    referenceData
  }
}

const setLoad = (load) => {
  return {
    type: REWARD.SET_LOAD,
    load
  }
}


export const addProduct = (reward, product) => {
  return {
    type: REWARD.ADD_PRODUCT,
    reward,
    product
  }
}

export const removeProduct = (reward, product) => {
  return {
    type: REWARD.REMOVE_PRODUCT,
    reward,
    product
  }
}

export const getReward = (uuid) => {
  return (dispatch) => {
    const load = rewardService.getReward(uuid).then((reward) => {
      dispatch(setReward(reward))
      return reward
    })
    dispatch(setLoad(load))
    return load
  }
}

export const createReward = (reward) => {
  return (dispatch) => {
    const load = rewardService.createReward(reward).then((updatedReward) => {
      dispatch(setReward(updatedReward))
      return updatedReward
    })
    dispatch(setLoad(load))
    return load
  }
}

export const saveReward = (uuid, reward) => {
  return (dispatch) => {
    const load = rewardService.saveReward(uuid, reward).then((updatedReward) => {
      dispatch(setReward(updatedReward))
      return updatedReward
    })
    dispatch(setLoad(load))
    return load
  }
}

export const getReferenceData = () => {
  return (dispatch) => {
    const load = rewardService.getReferenceData().then((data) => {
      dispatch(setReferenceData(data))
    })
    dispatch(setLoad(load))
    return load
  }
}


export default {
  setRewardValue,
  create: createReward,
  set: setReward,
  get: getReward,
  save: saveReward,
  addProduct,
  removeProduct,
  getReferenceData
}
